import { useState } from 'react';
import axios from 'axios';

const useFetchVendors = () => {
  const [loadingFetchVendorData, setLoadingFetchVendorData] = useState(false);
  const [errorFetchVendorData, setErrorFetchVendorData] = useState(null);

  const fetchVendorData = async () => {
    try {
      setLoadingFetchVendorData(true);
      setErrorFetchVendorData(null);

      const response = await axios.get(`/api/Vendor/get-all-vendors`, {
        headers: {
          'Content-Type': 'application/json',
        },
      });

      return response.data;
    } catch (err) {
      setErrorFetchVendorData(err);
      throw err;
    } finally {
      setLoadingFetchVendorData(false);
    }
  };

  return { fetchVendorData, loadingFetchVendorData, errorFetchVendorData };
};

export default useFetchVendors;
